import localforage from 'localforage';
import { AssetGoals } from '../type/AssetGoals.type';
import { v4 as uuidv4 } from 'uuid';
import { useAppStateLoadingCountStore } from '../../../common/store/AppStateStore.zustand';
import axios from 'axios';
import { SERVER_URL } from '../../../common/comstant/CommonConstants';

const assetGoalsStore = localforage.createInstance({
  name: 'honeymoonsalad',
  storeName: 'assetGoalsStore',
});

export const useAssetGoalsStore = () => {
  const { addCount, minusCount } = useAppStateLoadingCountStore();

  const exportAssetGoalsStore = async () => {
    if (!assetGoalsStore) return;

    const keys = await assetGoalsStore.keys();
    const entries = await Promise.all(keys.map(async (key) => ({ key, value: await assetGoalsStore.getItem(key) })));
    return entries;
    // const { data } = await axios.get<AssetGoals[]>(`${SERVER_URL}/asset-goals`);
    // return data.map((assetGoals) => ({ key: assetGoals.id, value: assetGoals }));
  };

  const importAssetGoalsStore = async (entries: { key: string; value: unknown }[]) => {
    if (!assetGoalsStore) return;

    await assetGoalsStore.clear();
    await Promise.all(entries.map(({ key, value }) => assetGoalsStore.setItem(key, value)));
    return true;
  };

  const clearAssetGoalsStore = async () => {
    if (!assetGoalsStore) return;

    await assetGoalsStore.clear();
    return true;
  };

  const insertAssetGoalsToStore = async (assetGoals: AssetGoals) => {
    if (!assetGoalsStore) return { data: '' };
    addCount();

    const assetGoalsId = assetGoals.id ? assetGoals.id : uuidv4().toString();
    assetGoals.id = assetGoalsId;
    await assetGoalsStore.setItem(assetGoalsId, assetGoals);

    minusCount();
    return { data: assetGoalsId };
  };

  const getAssetGoalsListFromStore = async () => {
    if (!assetGoalsStore) return { data: [] };
    addCount();

    const keys = await assetGoalsStore.keys();
    const assetGoalsList = await Promise.all(keys.map((key) => assetGoalsStore.getItem<AssetGoals>(key)));

    minusCount();
    return { data: assetGoalsList as AssetGoals[] };
  };

  const deleteAssetGoalsAtStore = async (id: string) => {
    if (!assetGoalsStore) return { data: null };
    addCount();

    const assetGoals = await assetGoalsStore.getItem<AssetGoals>(id);
    await assetGoalsStore.removeItem(id);

    minusCount();
    return { data: assetGoals };
  };

  return {
    assetGoalsStore,
    exportAssetGoalsStore,
    importAssetGoalsStore,
    clearAssetGoalsStore,
    insertAssetGoalsToStore,
    getAssetGoalsListFromStore,
    deleteAssetGoalsAtStore,
  };
};
